import e from "@dialpad/dialtone-tokens/layered/themes/tokens-127-colors.css?inline";
//#region themes/127.js
var t = { brand: {
	css: e,
	name: "127"
} };
//#endregion
export { t as default };
